import { render, staticRenderFns } from "./OverdueJobs.vue?vue&type=template&id=4d0881a2&scoped=true&"
import script from "./OverdueJobs.vue?vue&type=script&lang=ts&"
export * from "./OverdueJobs.vue?vue&type=script&lang=ts&"
import style0 from "./OverdueJobs.vue?vue&type=style&index=0&id=4d0881a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0881a2",
  null
  
)

export default component.exports